import MDAvatar from "components/MDAvatar";

// @mui icons
import Icon from "@mui/material/Icon";

// Images
import profilePicture from "assets/images/default-profile.png";

import Dashboard from "pages/dashboard/Dashboard";
import AccountSettings from "pages/account/AccountSettings";
import PomodoroTimer from "pages/timer/PomodoroTimer";
import GoalSetting from "pages/ai-coaching/GoalSetting";
import AIPlan from "pages/ai-coaching/AIPlan";
import AiReport from "pages/ai-coaching/AIReport";
import TaskCalendar from "pages/task/TaskCalendar";
import DailyCoach from "pages/task/DailyCoach";
import TaskManager from "pages/task/TaskManager";
import TaskProgress from "pages/task/TaskProgress";
import Story from "pages/growth-rate/Story";
import Partner from "pages/growth-rate/Partner";
import Reward from "pages/growth-rate/Reward";
import PersonalStatusRecord from "pages/growth-rate/PersonalStatusRecord";
import AiTalk from "pages/ai-talk/AiTalk";
import Admin from "pages/admin/Admin";
import Sales from "pages/admin/Sales";
import MessageCenter from "pages/MessageNotification/MessageCenter";
import FutureBoard from "pages/future-board/FutureBoard";
import { isFutureBoardBuildEnabled } from "@chronospark/shared";

// 未来ボードの入口は、明示的に有効にしたビルドだけに出す（VITE_FUTURE_BOARD_ENABLED=true）。
// サーバー側でも FUTURE_BOARD_ENABLED が有効になるまでは使えない。
const futureBoardRoutes = isFutureBoardBuildEnabled(import.meta.env.VITE_FUTURE_BOARD_ENABLED)
  ? [
      {
        name: "未来ボード",
        key: "FutureBoard",
        route: "/pages/ai-coaching/FutureBoard",
        component: <FutureBoard />,
        translationKey: "Breadcrumb.FutureBoard",
      },
    ]
  : [];

const routes = [
  {
    type: "collapse",
    name: "__USER_NAME__",
    key: "user-profile",
    translationKey: "Breadcrumb.AccountSettings",
    icon: <MDAvatar src={profilePicture} alt="user" size="sm" />,
    collapse: [
      {
        name: "アカウント設定",
        key: "AccountSettings",
        route: "/pages/account/AccountSettings",
        component: <AccountSettings />,
        translationKey: "Breadcrumb.AccountSettings"
      },
    ],
  },
  { type: "divider", key: "divider-0" },
  {
    type: "collapse",
    name: "ダッシュボード",
    key: "dashboard",
    icon: <Icon fontSize="medium">dashboard</Icon>,
    translationKey: "Breadcrumb.Dashboard-top",
    collapse: [
      {
        name: "ダッシュボード",
        key: "Dashboard",
        route: "/dashboard",
        component: <Dashboard />,
        translationKey: "Breadcrumb.Dashboard"
      },
    ],
  },
  {
    type: "title",
    title: "機能",
    key: "function-pages-title",
    translationKey: "Breadcrumb.Function-pages-title"
  },
  {
    type: "collapse",
    name: "タイマー",
    key: "timer-top",
    icon: <Icon fontSize="medium">alarm</Icon>,
    translationKey: "Breadcrumb.Timer-top",
    collapse: [
      {
        name: "ポモドーロタイマー",
        key: "PomodoroTimer",
        route: "/pages/timer/PomodoroTimer",
        component: <PomodoroTimer />,
        translationKey: "Breadcrumb.PomodoroTimer",
      },
    ],
  },
  {
    type: "collapse",
    name: "AIプラン作成",
    key: "ai-top",
    icon: <Icon fontSize="medium">smart_toy</Icon>,
    translationKey: "Breadcrumb.Ai-top",
    collapse: [
      {
        name: "目標設定",
        key: "GoalSetting",
        route: "/pages/ai-coaching/GoalSetting",
        component: <GoalSetting />,
        translationKey: "Breadcrumb.GoalSetting",
      },
      {
        name: "AIプラン作成",
        key: "AIPlan",
        route: "/pages/ai-coaching/AIPlan",
        component: <AIPlan />,
        translationKey: "Breadcrumb.AIPlan",
      },
      {
        name: "AIレポート",
        key: "AiReport",
        route: "/pages/ai-coaching/AiReport",
        component: <AiReport />,
        translationKey: "Breadcrumb.AiReport",
      },
      ...futureBoardRoutes,
    ],
  },
  {
    type: "collapse",
    name: "AI トーク",
    key: "AiTalk-top",
    icon: <Icon fontSize="medium">group</Icon>,
    translationKey: "Breadcrumb.AiTalk-top",
    collapse: [
      {
        name: "AI トーク",
        key: "AiTalk",
        route: "/pages/ai-talk/AiTalk",
        component: <AiTalk />,
        translationKey: "Breadcrumb.AiTalk",
      },
    ],
  },
  {
    type: "collapse",
    name: "タスク管理",
    key: "task-manager",
    icon: <Icon fontSize="medium">check_circle</Icon>,
    translationKey: "Breadcrumb.Task-manager-top",
    collapse: [
      {
        name: "スケジュール",
        icon: <Icon fontSize="medium">smart_toy</Icon>,
        key: "TaskCalendar",
        route: "/pages/task/TaskCalendar",
        component: <TaskCalendar />,
        translationKey: "Breadcrumb.TaskCalendar",
      },
      {
        name: "あなたのコーチ",
        icon: <Icon fontSize="medium">support_agent</Icon>,
        key: "DailyCoach",
        route: "/pages/task/DailyCoach",
        component: <DailyCoach />,
        translationKey: "Breadcrumb.DailyCoach",
      },
      {
        name: "一覧",
        key: "TaskManager",
        route: "/pages/task/TaskManager",
        component: <TaskManager />,
        translationKey: "Breadcrumb.TaskManager",
      },
      {
        name: "進捗",
        key: "TaskProgress",
        route: "/pages/task/TaskProgress",
        component: <TaskProgress />,
        translationKey: "Breadcrumb.TaskProgress",
      },
    ],
  },
  {
    type: "collapse",
    name: "クエスト",
    key: "gamification",
    icon: <Icon fontSize="medium">emoji_events</Icon>,
    translationKey: "Breadcrumb.Gamification",
    collapse: [
      {
        name: "ストーリー",
        key: "Story",
        route: "/pages/growth-rate/Story",
        component: <Story />,
        translationKey: "Breadcrumb.Story",
      },
      {
        name: "仲間選択",
        key: "Partner",
        route: "/pages/growth-rate/Partner",
        component: <Partner />,
        translationKey: "Breadcrumb.Partner",
      },
      {
        name: "報酬",
        key: "Reward",
        route: "/pages/growth-rate/Reward",
        component: <Reward />,
        translationKey: "Breadcrumb.Reward",
      },
      {
        name: "個人ステータス記録",
        key: "PersonalStatusRecord",
        route: "/pages/growth-rate/PersonalStatusRecord",
        component: <PersonalStatusRecord />,
        translationKey: "Breadcrumb.PersonalStatusRecord",
      },
    ],
  },
  {
    type: "collapse",
    name: "通知",
    key: "MessageCenter-top",
    icon: <Icon fontSize="medium">notifications</Icon>,
    translationKey: "Breadcrumb.MessageCenter",
    collapse: [
      {
        name: "通知センター",
        key: "MessageCenter",
        route: "/pages/MessageNotification/MessageCenter",
        component: <MessageCenter />,
        translationKey: "Breadcrumb.MessageCenter",
      },
    ],
  },
  { type: "divider", key: "divider-1" },
];

export default routes;
